module.exports = __webpack_public_path__ + "img/video_noData.ad5eb7de.png";